import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=4805d064&"
import script from "./SupportForm.vue?vue&type=script&lang=ts&"
export * from "./SupportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports